export default "__VITE_ASSET__D8bnmJu0__"